"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagPickerContextValues", {
    enumerable: true,
    get: function() {
        return useTagPickerContextValues;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useTagPickerContextValues(state) {
    const { onOptionClick, registerOption, selectedOptions, selectOption, value, triggerRef, secondaryActionRef, tagPickerGroupRef, targetRef, size, setValue, setOpen, setHasFocus, popoverRef, appearance, clearSelection, getOptionById, getOptionsMatchingValue, open, popoverId, disabled } = state;
    return {
        activeDescendant: _react.useMemo(()=>({
                controller: state.activeDescendantController
            }), [
            state.activeDescendantController
        ]),
        listbox: {
            onOptionClick,
            registerOption,
            getOptionById,
            getOptionsMatchingValue,
            selectedOptions,
            selectOption,
            focusVisible: false,
            setActiveOption: noop
        },
        picker: {
            value,
            triggerRef,
            targetRef,
            secondaryActionRef,
            tagPickerGroupRef,
            size,
            setValue,
            setOpen,
            setHasFocus,
            selectOption,
            popoverRef,
            selectedOptions,
            appearance,
            clearSelection,
            getOptionById,
            open,
            popoverId,
            disabled
        }
    };
}
const noop = ()=>{
/** noop */ };
